/* eslint-disable no-console */
export const consoleShim = {
	nopify: function() {
		const methods = ["assert", "cd", "clear", "count", "countReset",
			"debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed",
			"groupEnd", "info", "log", "markTimeline", "profile", "profileEnd",
			"select", "table", "time", "timeEnd", "timeStamp", "timeline",
			"timelineEnd", "trace", "warn"];

		const noop = function() { };
		for(const method of methods) {
			if(!console[method])
				console[method] = noop;
		}
	},

	shimConsole: function() {
		window.vesl = window.vesl || {};

		this.nopify();
	}
};
